import React, { useState } from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const ElectricBilling = () => {
  const [isReceiptOpen, setIsReceiptOpen] = useState(false);
  const handleReceiptClick = (row, index) => {
    console.log("Clicked receipt", index, "for:", row);
    setIsReceiptOpen(true);
  };

  const columns = [
    {
      key: "receiptId",
      label: "Receipt id/Time",
      render: (row) => (
        <div>
          <div>{row.receiptId}</div>
          <div style={{ color: "#f97316", fontSize: "12px" }}>{row.time}</div>
        </div>
      ),
    },
    {
      key: "months",
      label: "Months",
      render: (row) => <div>{row.months}</div>,
    },
    {
      key: "billingDate",
      label: "Billing date",
      render: (row) => <div>{row.billingDate}</div>,
    },
    {
      key: "billingAmount",
      label: "Billing amount (INR)",
      render: (row) => <div>₹ {row.billingAmount}</div>,
    },
    {
      key: "paidAmount",
      label: "Paid amount (INR)",
      render: (row) => (
        <div>
          <div>₹ {row.paidAmount}</div>
          <div style={{ fontSize: "12px", color: "#64748b" }}>
            {row.paymentMethod}
          </div>
        </div>
      ),
    },
    {
      key: "provider",
      label: "Provider",
      render: (row) => <div>{row.provider}</div>,
    },
    {
      key: "confirmedBy",
      label: "Confirmed by",
      render: (row) => (
        <div style={{ color: "#22c55e" }}>{row.confirmedBy}</div>
      ),
    },
    {
      key: "receipts",
      label: "Receipts",
      render: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {row.receipts.map((receipt, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span
                onClick={() => handleReceiptClick(row, i)}
                style={{
                  color: "#5D87FF",
                  cursor: "pointer",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                Receipt
                <BsBoxArrowRight />
              </span>
              {receipt.status && (
                <span
                  style={{
                    fontSize: "12px",
                    padding: "2px 8px",
                    backgroundColor:
                      receipt.status === "All paid" ? "#4CAF50" : "#F29339",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  {receipt.status}
                </span>
              )}
            </div>
          ))}
        </div>
      ),
    },
  ];

  const historyData = [
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      months: "January, February",
      billingDate: "02 Oct, 2025",
      billingAmount: 18000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      provider: "WBSEDCL",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "Pay due" }],
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      months: "January, February",
      billingDate: "02 Oct, 2025",
      billingAmount: 18000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      provider: "WBSEDCL",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "All paid" }],
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      months: "January, February",
      billingDate: "02 Oct, 2025",
      billingAmount: 18000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      provider: "WBSEDCL",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "Pay due" }],
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      months: "January, February",
      billingDate: "02 Oct, 2025",
      billingAmount: 18000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      provider: "WBSEDCL",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "Pay due" }, { status: "Pay due" }],
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      months: "January, February",
      billingDate: "02 Oct, 2025",
      billingAmount: 18000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      provider: "WBSEDCL",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "Pay due" }],
    },
  ];

  const _this = { columns, historyData, isReceiptOpen, setIsReceiptOpen };
  return <Body {..._this} />;
};

export default ElectricBilling;
